import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"
import { Row, Col, CardBody, Card, Input } from "reactstrap"

// Formik Validation
import * as Yup from "yup"
import { useFormik } from "formik"
import SocialLinkUpdate from "./SocialLink/SocialLinkUpdate"

import { Link, useLocation, useNavigate } from "react-router-dom"
import withRouter from "../../components/Common/withRouter"
import { Bounce, toast } from "react-toastify"

// import images
import logo from "assets/images/logo-dark.png"
import logolight from "assets/images/logo-light.png"
import logoLg from "assets/images/header-logo-lg.svg"

import SocialLink from "./SocialLink/SocialLink"
import { PayPalButtons } from "@paypal/react-paypal-js"
import { post } from "api/axios"
import endpoints from "api/endpoints"

const Subscription = props => {
  document.title = " Register | Dock Tok"
  const navigate = useNavigate()
  const location = useLocation()
  const queryString = location.search
  const params = new URLSearchParams(queryString)
  const handleClick = () => {
    navigate("/admin")
  }
  const [couponCode, setCouponCode] = useState("")

  // const dispatch = useDispatch()
  const handleSubscription = async () => {
    const resp = await post(`${endpoints.subscription}/create`, {
      couponCode: couponCode,
    })
    if (resp?.data?.success) {
      console.log(resp.data, "SUCCESS")
      window.location.href = resp.data.approvalLink
    } else {
      toast.error(resp.response.data.error, {
        position: "bottom-center",
        theme: "colored",
        transition: Bounce,
      })
    }
  }

  useEffect(() => {
    document.body.className = "authentication-bg"
    // remove classname when component will unmount
  }, [])

  return (
    <Row className="row-gap-2 row-gap-md-4 mx-md-5 mx-lg-0 px-md-5 my-5 py-0 login-scroll">
      <Col lg={12}>
        <div className="text-center">
          <Link to="/" className="mb-3 d-block auth-logo mt-5 mt-md-5 mt-lg-5 ">
            <img src={logo} alt="" height="80" className="logo logo-light" />
            <img src={logoLg} alt="" height="80" className="logo logo-dark" />
          </Link>
        </div>
      </Col>

      <Col xs="12">
        <div className="d-flex flex-column text-center px-2 justify-content-center">
          <span className="text-uppercase font-size-32 fw-bolder lh-1 pText responsive-font-clamp">
            Buy subscription
          </span>

          <div className="pt-4 gap-0">
            <Row className="justify-content-center">
              <Col xs="12" sm="6" md="auto" className="">
                <Card
                  className="rounded-4 d-flex flex-column justify-content-center pre-color p-0 card-size"
                  style={{
                    background:
                      "linear-gradient(to right, rgba(255, 255, 255, 0.0005), #64b98b 35%)",
                  }}
                >
                  <CardBody className="d-flex align-items-center p-1 ps-2">
                    <Row className="d-flex align-items-center">
                      <Col xs="auto" className="ps-2">
                        <h2
                          className="d-flex justify-content-center align-items-center fw-medium font-size-26 pre-color m-0 rounded-4 text-black bg-white"
                          style={{ height: "70px", width: "70px" }}
                        >
                          01
                        </h2>
                      </Col>
                      <Col>
                        <div className="d-flex flex-column text-start pe-1">
                          <span className="fw-normal font-size-12 text-white">
                            Start uploading videos, sharing jokes, and upvoting
                            jokes for your chance to win prizes and get featured
                            on Dock Tok social media.Start your subscription
                            ($4.99/month)
                          </span>
                        </div>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                <div className="mb-3">
                  <Input
                    name="coupon"
                    className="form-control"
                    placeholder="Enter your Coupon Code"
                    type="text"
                    onChange={e => {
                      setCouponCode(e.target.value)
                    }}
                  />
                </div>
                <button
                  className="btn btn-primary-green"
                  onClick={e => {
                    console.log("Subscription")
                    handleSubscription()
                  }}
                >
                  Buy Subscription Now ($4.99/month)
                </button>
              </Col>
            </Row>
          </div>
        </div>
      </Col>

      <div className="d-flex d-md-none justify-content-center">
        <button className="btn btn-primary-green" onClick={handleClick}>
          LOGIN AS ADMIN
        </button>
      </div>
    </Row>
  )
}
export default withRouter(Subscription)

// Subscription.propTypes = {
//   registerUser: PropTypes.func,
//   // registerUserFailed: PropTypes.func,
//   registrationError: PropTypes.any,
//   user: PropTypes.any,
// }
